/**
 * kult-roast-chart.js — Interaktives Röstdiagramm (Über uns → Röstverfahren), Fassung 2 vom 30.09.2026.
 * Ein Panel „Geschmack in der Tasse“: Säure, Aroma, Fülle & Intensität über 0–25 Min. Die Rösttemperatur liegt
 * als durchschimmernde Fläche im Hintergrund (Kult bis 20 Min. im Band ca. 180–200 °C, Industrie steil bis 5 Min.).
 * Die Kurvennamen laufen als Tags an den Punkten mit, die Bohne im Titel färbt sich mit der Minute, die
 * Röstphasen (Trocknen, Bräunung, First Crack, Entwicklung) liegen als Leiste auf der Zeitachse.
 * Zeitstrahl läuft in 5-Minuten-Schritten automatisch, sobald das Diagramm sichtbar wird; Regler und Play-Taste
 * übernehmen jederzeit. Reduced Motion: keine Animation, Diagramm steht auf dem Kult-Punkt (20 Min.).
 */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SVGNS = 'http://www.w3.org/2000/svg';

  /* Vereinfachte Kurven, 0–25 Minuten, Wert je Minute (0 = weniger, 1 = mehr) */
  var CURVES = {
    acid:  [1, .99, .98, .97, .96, .94, .92, .90, .88, .85, .82, .79, .75, .71, .66, .61, .55, .49, .43, .37, .31, .26, .21, .16, .12, .09],
    aroma: [0, .10, .19, .27, .35, .42, .49, .55, .60, .65, .69, .73, .76, .79, .81, .83, .845, .855, .862, .866, .868, .866, .855, .83, .79, .73],
    body:  [0, .02, .04, .06, .09, .12, .15, .18, .22, .26, .30, .35, .40, .45, .51, .57, .63, .69, .75, .81, .868, .92, .96, .985, 1, 1]
  };
  /* Rösttemperatur als Anteil der Panelhöhe: 180 °C ≙ 0.74, 200 °C ≙ 0.86, darüber „deutlich heißer“ */
  var TEMP_KULT = [.18, .24, .30, .36, .42, .48, .53, .58, .62, .66, .69, .72, .74, .76, .78, .795, .81, .82, .83, .84, .85];
  var TEMP_IND = [.18, .45, .72, .90, .98, 1];
  var BAND = [.74, .86];
  var PHASES = [{ from: 0, to: 5, name: 'Trocknen' }, { from: 5, to: 12, name: 'Bräunung' }, { from: 12, to: 15, name: 'First Crack' }, { from: 15, to: 20, name: 'Entwicklung' }];
  var NAMES = { acid: 'Säure', aroma: 'Aroma', body: 'Fülle & Intensität' };
  /* Bohnenfarbe je Minute (wie snippets/kult-roast-timeline): grün → gelblich → hellbraun → röstbraun → überröstet */
  var BEAN = [{ t: 0, c: [127, 163, 107] }, { t: 5, c: [201, 168, 106] }, { t: 12, c: [163, 103, 46] }, { t: 20, c: [74, 42, 21] }, { t: 25, c: [40, 22, 12] }];

  function at(arr, t) {
    var max = arr.length - 1;
    if (t <= 0) return arr[0];
    if (t >= max) return arr[max];
    var i = Math.floor(t), f = t - i;
    return arr[i] + (arr[i + 1] - arr[i]) * f;
  }
  function ease(p) { return p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2; }
  function level(v) { return v >= 0.72 ? 'hoch' : v >= 0.4 ? 'mittel' : 'niedrig'; }
  function fmt(t) { var mm = Math.floor(t), ss = Math.round((t - mm) * 60); if (ss === 60) { mm++; ss = 0; } return mm + ':' + (ss < 10 ? '0' : '') + ss; }
  function beanColor(t) {
    for (var i = 1; i < BEAN.length; i++) {
      if (t <= BEAN[i].t) {
        var a = BEAN[i - 1], b = BEAN[i], f = (t - a.t) / (b.t - a.t);
        return 'rgb(' + a.c.map(function (v, k) { return Math.round(v + (b.c[k] - v) * f); }).join(',') + ')';
      }
    }
    return 'rgb(' + BEAN[BEAN.length - 1].c.join(',') + ')';
  }
  function phaseAt(t, kult) {
    if (t > kult + 0.01) return 'Überröstet';
    for (var i = 0; i < PHASES.length; i++) if (t < PHASES[i].to || i === PHASES.length - 1) return PHASES[i].name;
    return '';
  }
  /* Catmull-Rom → kubische Bézier-Segmente für weiche Kurven */
  function smoothPath(pts) {
    var d = 'M' + pts[0][0].toFixed(1) + ' ' + pts[0][1].toFixed(1);
    for (var i = 0; i < pts.length - 1; i++) {
      var p0 = pts[i - 1] || pts[i], p1 = pts[i], p2 = pts[i + 1], p3 = pts[i + 2] || p2;
      d += ' C' + (p1[0] + (p2[0] - p0[0]) / 6).toFixed(1) + ' ' + (p1[1] + (p2[1] - p0[1]) / 6).toFixed(1) + ', ' + (p2[0] - (p3[0] - p1[0]) / 6).toFixed(1) + ' ' + (p2[1] - (p3[1] - p1[1]) / 6).toFixed(1) + ', ' + p2[0].toFixed(1) + ' ' + p2[1].toFixed(1);
    }
    return d;
  }
  function el(tag, attrs, text) {
    var n = document.createElementNS(SVGNS, tag);
    for (var k in attrs) n.setAttribute(k, attrs[k]);
    if (text != null) n.textContent = text;
    return n;
  }
  function textWidth(node, fallback) { try { var w = node.getComputedTextLength(); return w > 0 ? w : fallback; } catch (e) { return fallback; } }

  document.querySelectorAll('[data-roast-chart]').forEach(function (root) {
    var MAX = parseFloat(root.dataset.rcMax) || 25;
    var STEP = parseFloat(root.dataset.rcStep) || 5;
    var IND = parseFloat(root.dataset.rcIndustry) || 5;
    var KULT = parseFloat(root.dataset.rcKult) || 20;
    var HOLD = parseInt(root.dataset.rcHold, 10) || 1700;
    var host = root.querySelector('[data-rc-svg]');
    var range = root.querySelector('[data-rc-range]');
    var playBtn = root.querySelector('[data-rc-play]');
    var minuteEl = root.querySelector('[data-rc-minute]');
    var stageEl = root.querySelector('[data-rc-stage]');
    var subEl = root.querySelector('[data-rc-sub]');
    var textEl = root.querySelector('[data-rc-text]');
    var beanEl = root.querySelector('[data-rc-bean]');
    var bars = { acid: root.querySelector('[data-rc-bar="acid"]'), aroma: root.querySelector('[data-rc-bar="aroma"]'), body: root.querySelector('[data-rc-bar="body"]') };
    var chips = { ind: root.querySelector('[data-rc-chip="industry"]'), kult: root.querySelector('[data-rc-chip="kult"]') };
    var labels = {};
    root.querySelectorAll('[data-rc-step]').forEach(function (n) { labels[n.dataset.rcStep] = { name: n.dataset.rcName, text: n.textContent.trim() }; });

    /* Stufenliste (mobil, .kult-rc--steps): Werte, Phase und Bohnenfarbe je Minute aus denselben Kurven wie das Diagramm */
    root.querySelectorAll('[data-rc-step-row]').forEach(function (row) {
      var m = parseFloat(row.dataset.rcStepRow) || 0;
      var bean = row.querySelector('[data-rc-step-bean]'), phase = row.querySelector('[data-rc-step-phase]');
      if (bean) bean.style.fill = beanColor(m);
      if (phase) phase.textContent = phaseAt(m, KULT);
      row.querySelectorAll('[data-rc-step-bar]').forEach(function (bar) {
        var v = at(CURVES[bar.dataset.rcStepBar] || [0], m);
        bar.style.setProperty('--rc-v', (v * 100).toFixed(0) + '%');
        var lv = bar.parentNode.querySelector('[data-rc-step-level]'); if (lv) lv.textContent = level(v);
      });
    });
    if (!host || !range) return;

    var t = reduced ? KULT : 0, geo = null, dyn = null, raf = null, timer = null, playing = false, finished = false;

    function build() {
      var W = host.clientWidth;
      if (!W) return;
      var mobile = W < 640;
      /* Mobil: Temperaturskala innen am rechten Rand, damit die Zeitachse breit bleibt */
      var m = { l: mobile ? 44 : 56, r: mobile ? 14 : 92, t: 24, b: 60 };
      var H = mobile ? 390 : 450;
      var plotW = W - m.l - m.r, h1 = H - m.t - m.b, y1b = m.t + h1;
      var x = function (v) { return m.l + plotW * v / MAX; };
      var yF = function (v) { return y1b - 6 - v * (h1 - 14); };
      geo = { W: W, m: m, x: x, yF: yF, y1b: y1b, plotW: plotW, mobile: mobile };

      var uid = (root.id || 'rc').replace(/[^a-z0-9-]/gi, '');
      var svg = el('svg', { viewBox: '0 0 ' + W + ' ' + H, width: W, height: H, class: 'kult-rc__svg', 'aria-hidden': 'true', focusable: 'false' });
      var defs = el('defs');
      var clip = el('clipPath', { id: uid + '-clip' }); var clipRect = el('rect', { x: m.l - 4, y: 0, width: 0, height: H }); clip.appendChild(clipRect); defs.appendChild(clip);
      var grad = el('linearGradient', { id: uid + '-heat', x1: 0, y1: 0, x2: 0, y2: 1 });
      grad.appendChild(el('stop', { offset: '0', class: 'kult-rc__heat-stop kult-rc__heat-stop--top' }));
      grad.appendChild(el('stop', { offset: '1', class: 'kult-rc__heat-stop kult-rc__heat-stop--bottom' }));
      defs.appendChild(grad); svg.appendChild(defs);

      /* Hintergrund: Industrie-Zone, Temperaturflächen, Raster */
      svg.appendChild(el('rect', { class: 'kult-rc__zone', x: x(0), y: m.t, width: x(IND) - x(0), height: y1b - m.t }));
      function pts(arr, from, to) { var p = []; for (var i = from; i <= to; i++) p.push([x(i), yF(arr[i])]); return p; }
      var indLine = smoothPath(pts(TEMP_IND, 0, IND)), kultLine = smoothPath(pts(TEMP_KULT, 0, KULT));
      svg.appendChild(el('path', { class: 'kult-rc__heat kult-rc__heat--industry', d: indLine + ' L' + x(IND).toFixed(1) + ' ' + y1b + ' L' + x(0).toFixed(1) + ' ' + y1b + ' Z' }));
      svg.appendChild(el('path', { class: 'kult-rc__heat kult-rc__heat--kult', fill: 'url(#' + uid + '-heat)', d: kultLine + ' L' + x(KULT).toFixed(1) + ' ' + y1b + ' L' + x(0).toFixed(1) + ' ' + y1b + ' Z' }));
      svg.appendChild(el('path', { class: 'kult-rc__heat-line kult-rc__heat-line--industry', d: indLine }));
      svg.appendChild(el('path', { class: 'kult-rc__heat-line kult-rc__heat-line--kult', d: kultLine }));
      /* Temperatur-Beschriftung tief in der Fläche, wo keine Geschmackskurve verläuft */
      svg.appendChild(el('text', { class: 'kult-rc__heat-label', x: x(17.5), y: yF(0.26), 'text-anchor': 'middle' }, mobile ? 'Temperatur Kult' : 'Rösttemperatur Kult: ca. 180–200 °C'));
      if (!mobile) svg.appendChild(el('text', { class: 'kult-rc__heat-label kult-rc__heat-label--industry', x: x(1.6) + 6, y: yF(at(TEMP_IND, 1.6)) + 4 }, 'Temperatur Industrie'));
      /* Temperaturskala am rechten Rand: Band ca. 180–200 °C mit Hilfslinien, darüber „heißer“ */
      var tickX = mobile ? m.l + plotW - 4 : m.l + plotW + 8, tickAnchor = mobile ? 'end' : 'start';
      [BAND[0], BAND[1]].forEach(function (v, i) {
        svg.appendChild(el('line', { class: 'kult-rc__temp-guide', x1: m.l, x2: m.l + plotW, y1: yF(v), y2: yF(v) }));
        svg.appendChild(el('text', { class: 'kult-rc__temp-tick', x: tickX, y: yF(v) + (mobile ? -3 : 4), 'text-anchor': tickAnchor }, (i === 0 ? '180' : '200') + ' °C'));
      });
      svg.appendChild(el('text', { class: 'kult-rc__temp-tick', x: tickX, y: m.t + 10, 'text-anchor': tickAnchor }, 'heißer'));
      if (!mobile) {
        var ty = m.t + h1 / 2, tx = W - 12;
        svg.appendChild(el('text', { class: 'kult-rc__temp-title', x: tx, y: ty, 'text-anchor': 'middle', transform: 'rotate(-90 ' + tx + ' ' + ty + ')' }, 'Rösttemperatur'));
      }
      for (var g = 0; g <= MAX; g += STEP) {
        svg.appendChild(el('line', { class: 'kult-rc__grid', x1: x(g), x2: x(g), y1: m.t, y2: y1b }));
        svg.appendChild(el('text', { class: 'kult-rc__tick', x: x(g), y: y1b + 50, 'text-anchor': 'middle' }, g === 0 ? '0 Min.' : String(g)));
      }
      svg.appendChild(el('line', { class: 'kult-rc__axis', x1: m.l, x2: m.l + plotW, y1: y1b, y2: y1b }));
      svg.appendChild(el('text', { class: 'kult-rc__axis-label', x: m.l - 8, y: m.t + 10, 'text-anchor': 'end' }, 'mehr'));
      svg.appendChild(el('text', { class: 'kult-rc__axis-label', x: m.l - 8, y: y1b - 2, 'text-anchor': 'end' }, 'weniger'));
      svg.appendChild(el('text', { class: 'kult-rc__panel', x: m.l, y: m.t - 9 }, 'Geschmack in der Tasse'));

      /* Röstphasen als Leiste auf der Zeitachse (Beschriftung nur, wenn sie ins Segment passt) */
      var phaseList = PHASES.concat([{ from: KULT, to: MAX, name: 'danach', after: true }]);
      phaseList.forEach(function (p) {
        var px = x(p.from) + 1, pw = x(p.to) - x(p.from) - 2;
        svg.appendChild(el('rect', { class: 'kult-rc__phase' + (p.after ? ' kult-rc__phase--after' : ''), x: px, y: y1b + 10, width: pw, height: 22, rx: 5 }));
        var label = el('text', { class: 'kult-rc__phase-label' + (p.after ? ' kult-rc__phase-label--after' : ''), x: px + pw / 2, y: y1b + 25, 'text-anchor': 'middle' }, p.name);
        svg.appendChild(label);
        if (textWidth(label, p.name.length * 6.5) > pw - 8) label.remove();
      });

      /* Kurven: blass in voller Länge, kräftig bis zum Zeitzeiger (Clip); ab Kult-Punkt gestrichelt */
      var faint = el('g', { class: 'kult-rc__faint' }), strong = el('g', { 'clip-path': 'url(#' + uid + '-clip)' });
      ['acid', 'aroma', 'body'].forEach(function (key) {
        var solid = smoothPath(pts(CURVES[key], 0, KULT)), dashed = smoothPath(pts(CURVES[key], KULT, MAX));
        [faint, strong].forEach(function (grp) {
          grp.appendChild(el('path', { class: 'kult-rc__line kult-rc__line--' + key, d: solid }));
          grp.appendChild(el('path', { class: 'kult-rc__line kult-rc__line--' + key + ' kult-rc__line--after', d: dashed }));
        });
      });
      svg.appendChild(faint); svg.appendChild(strong);

      /* Marker Industrie (5 Min.) und Kult (20 Min.), Kult-Punkt am Schnittpunkt Aroma/Fülle */
      svg.appendChild(el('line', { class: 'kult-rc__marker kult-rc__marker--industry', x1: x(IND), x2: x(IND), y1: m.t, y2: y1b + 32 }));
      svg.appendChild(el('line', { class: 'kult-rc__marker kult-rc__marker--kult', x1: x(KULT), x2: x(KULT), y1: m.t, y2: y1b + 32 }));
      var cross = el('g', { class: 'kult-rc__cross' });
      cross.appendChild(el('circle', { class: 'kult-rc__cross-ring', cx: x(KULT), cy: yF(CURVES.aroma[KULT]), r: 14 }));
      cross.appendChild(el('circle', { class: 'kult-rc__cross-dot', cx: x(KULT), cy: yF(CURVES.aroma[KULT]), r: 5 }));
      svg.appendChild(cross);

      /* Zeitzeiger, Punkte und mitlaufende Tags */
      var head = el('line', { class: 'kult-rc__head', x1: x(0), x2: x(0), y1: m.t, y2: y1b });
      svg.appendChild(head);
      var dots = {}, tags = {};
      ['acid', 'aroma', 'body'].forEach(function (key) {
        dots[key] = el('circle', { class: 'kult-rc__dot kult-rc__dot--' + key, r: 5 });
        var g = el('g', { class: 'kult-rc__tag kult-rc__tag--' + key });
        var rect = el('rect', { rx: 10, ry: 10, height: 20, y: -10, x: 0 });
        var txt = el('text', { x: 9, y: 4 }, mobile && key === 'body' ? 'Fülle' : NAMES[key]);
        g.appendChild(rect); g.appendChild(txt);
        tags[key] = { g: g, rect: rect, txt: txt, w: 0 };
      });
      svg.appendChild(dots.acid); svg.appendChild(dots.aroma); svg.appendChild(dots.body);
      svg.appendChild(tags.acid.g); svg.appendChild(tags.aroma.g); svg.appendChild(tags.body.g);
      host.innerHTML = ''; host.appendChild(svg);
      ['acid', 'aroma', 'body'].forEach(function (key) {
        var w = Math.ceil(textWidth(tags[key].txt, tags[key].txt.textContent.length * 6.6)) + 18;
        tags[key].w = w; tags[key].rect.setAttribute('width', w);
      });
      dyn = { clipRect: clipRect, head: head, dots: dots, tags: tags };

      /* Marker-Chips in der Leiste über dem Diagramm: rechts der Mitte nach links geklappt, über `right` positioniert */
      function placeChip(chip, v) {
        if (!chip) return;
        var pct = x(v) / W * 100, flip = pct > 62;
        chip.classList.toggle('kult-rc__chip--flip', flip);
        chip.style.left = flip ? 'auto' : pct + '%';
        chip.style.right = flip ? (100 - pct) + '%' : 'auto';
      }
      placeChip(chips.ind, IND); placeChip(chips.kult, KULT);
      render();
    }

    function render() {
      if (!geo || !dyn) return;
      var xx = geo.x(t);
      dyn.clipRect.setAttribute('width', Math.max(0, xx - geo.m.l + 4));
      dyn.head.setAttribute('x1', xx); dyn.head.setAttribute('x2', xx);
      /* Punkte + Tags: Tags rechts vom Punkt, nahe dem rechten Rand links; bei Nähe untereinander gestapelt */
      var items = ['acid', 'aroma', 'body'].map(function (key) {
        var y = geo.yF(at(CURVES[key], t));
        dyn.dots[key].setAttribute('cx', xx); dyn.dots[key].setAttribute('cy', y);
        return { key: key, y: y, w: dyn.tags[key].w };
      });
      items.sort(function (a, b) { return a.y - b.y; });
      var minGap = 22, top = geo.m.t + 12, bottom = geo.y1b - 12;
      for (var i = 1; i < items.length; i++) if (items[i].y - items[i - 1].y < minGap) items[i].y = items[i - 1].y + minGap;
      var over = items[items.length - 1].y - bottom;
      if (over > 0) items.forEach(function (it) { it.y -= over; });
      for (var j = 0; j < items.length; j++) if (items[j].y < top) items[j].y = top + j * minGap;
      var maxW = Math.max.apply(null, items.map(function (it) { return it.w; }));
      var right = xx + 12 + maxW <= geo.m.l + geo.plotW;
      items.forEach(function (it) {
        var tx = right ? xx + 12 : xx - 12 - it.w;
        dyn.tags[it.key].g.setAttribute('transform', 'translate(' + tx.toFixed(1) + ' ' + it.y.toFixed(1) + ')');
      });
      root.classList.toggle('kult-rc--at-kult', Math.abs(t - KULT) < 0.01);
      root.classList.toggle('kult-rc--past-kult', t > KULT + 0.01);
      var step = Math.round(t / STEP) * STEP, lab = labels[step] || labels[0];
      if (minuteEl) minuteEl.textContent = fmt(t) + ' Min.';
      if (stageEl) stageEl.textContent = phaseAt(t, KULT);
      if (subEl && lab) subEl.textContent = lab.name;
      if (textEl && lab) textEl.textContent = lab.text;
      if (beanEl) beanEl.style.fill = beanColor(t);
      ['acid', 'aroma', 'body'].forEach(function (key) {
        var v = at(CURVES[key], t), bar = bars[key];
        if (!bar) return;
        bar.style.setProperty('--rc-v', (v * 100).toFixed(0) + '%');
        var lv = bar.parentNode.querySelector('[data-rc-level]'); if (lv) lv.textContent = level(v);
      });
      range.value = String(Math.round(t));
      range.setAttribute('aria-valuetext', Math.round(t) + ' Minuten, ' + phaseAt(t, KULT) + (lab ? ', ' + lab.name : ''));
    }

    function tween(to, done) {
      if (raf) cancelAnimationFrame(raf);
      if (reduced) { t = to; render(); if (done) done(); return; }
      var from = t, start = null, dur = 700 + Math.abs(to - from) * 60;
      function frame(ts) {
        if (!start) start = ts;
        var p = Math.min(1, (ts - start) / dur);
        t = from + (to - from) * ease(p);
        render();
        if (p < 1) raf = requestAnimationFrame(frame); else { raf = null; if (done) done(); }
      }
      raf = requestAnimationFrame(frame);
    }
    function holdFor(v) { return v === KULT ? HOLD * 2 : v >= MAX ? HOLD * 1.5 : HOLD; }
    function next() {
      if (!playing) return;
      var cur = Math.round(t / STEP) * STEP, nt = cur + STEP;
      if (nt > MAX) { playing = false; finished = true; setPlayUi(); tween(KULT); return; }
      tween(nt, function () { if (playing) timer = setTimeout(next, holdFor(nt)); });
    }
    function play() {
      if (reduced) return;
      if (finished || t >= MAX) { finished = false; t = 0; render(); }
      playing = true; setPlayUi();
      timer = setTimeout(next, t === 0 ? 900 : 300);
    }
    function stop() { playing = false; clearTimeout(timer); setPlayUi(); }
    function setPlayUi() {
      if (!playBtn) return;
      playBtn.setAttribute('aria-pressed', playing ? 'true' : 'false');
      var l = playBtn.querySelector('[data-rc-play-label]');
      if (l) l.textContent = playing ? playBtn.dataset.labelPause : (finished ? playBtn.dataset.labelAgain : playBtn.dataset.labelPlay);
    }

    range.addEventListener('input', function () { stop(); finished = false; tween(parseFloat(range.value)); });
    if (playBtn) playBtn.addEventListener('click', function () { if (playing) stop(); else play(); });

    build();
    var rt = null;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(build, 150); });

    if (!reduced && 'IntersectionObserver' in window) {
      var started = false;
      var io = new IntersectionObserver(function (entries) {
        /* Autoplay nur, wenn die Kurven sichtbar sind (mobil mit Stufenliste ist die Bühne ausgeblendet) */
        entries.forEach(function (e) { if (e.isIntersecting && !started) { started = true; io.disconnect(); if (host.clientWidth) play(); } });
      }, { threshold: 0.25 });
      io.observe(root);
    }
  });
})();
